import { NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';
import { canActivateThankyou } from './guards/enable-thankyou-route.guard';
import { LoginComponent } from './components/login/login.component';
import { AuthGuard } from './guards/auth-guard.guard';
import { CommonDashbaordComponent } from './components/common-dashbaord/common-dashbaord.component';
import { SignupComponent } from '../../myt/utils/standalone-components/signup/signup.component';
import { NotAuthGuard } from './guards/not-auth.guard';
import { RouteLoaderPolicyData } from './core/loading/models/loader-policy.models';

const ticketingRouteLoaderPolicy: RouteLoaderPolicyData = {
  moduleKey: 'ticketing',
  mode: 'top-bar',
  routeKey: '/tickets',
  scope: { type: 'route', key: '/tickets' },
};

const whatsappRouteLoaderPolicy: RouteLoaderPolicyData = {
  moduleKey: 'whatsapp',
  mode: 'top-bar',
  routeKey: '/agent-platform',
  scope: { type: 'route', key: '/agent-platform' },
};

const routes: Routes = [
  {
    path: '',
    loadChildren: () =>
      import('./routes/route-home.module').then((u) => u.RouteHomeModule),
    pathMatch: 'full',
  },
  {
    path: 'itr/itr-filing',
    loadChildren: () =>
      import('./routes/route-itr-home.module').then(
        (m) => m.RouteItrHomeModule,
      ),
  },
  {
    path: 'blogs',
    loadChildren: () =>
      import('./routes/route-blog.module').then((u) => u.RouteBlogModule),
  },
  {
    path: 'contact-us',
    loadChildren: () =>
      import('./routes/route-contact-us.module').then(
        (u) => u.RouteContactUsModule,
      ),
  },
  {
    path: 'about-us',
    loadChildren: () =>
      import('./routes/route-about-us.module').then(
        (u) => u.RouteAboutUsModule,
      ),
  },
  {
    path: 'all-services',
    loadChildren: () =>
      import('./routes/route-all-services.module').then(
        (u) => u.RouteAllServicesModule,
      ),
  },
  {
    path: 'calculators',
    loadChildren: () =>
      import('./routes/route-calculator.module').then(
        (u) => u.RouteCalculatorModule,
      ),
  },
  {
    path: 'content-management',
    canActivateChild: [AuthGuard],
    data: { roles: ['ADMIN', 'REVIEWER', 'BLOG'] },
    loadChildren: () =>
      import('./routes/route-content-management.module').then(
        (u) => u.RouteContentManagementModule,
      ),
  },
  {
    path: 'services',
    loadChildren: () =>
      import('./routes/route-services.module').then(
        (u) => u.RouteServicesModule,
      ),
  },
  {
    path: 'dashboard',
    component: CommonDashbaordComponent,
  },
  {
    path: 'admin',
    data: { roles: ['ADMIN'] },
    canActivateChild: [AuthGuard],
    loadChildren: () =>
      import('./routes/route-admin.module').then((m) => m.RouteAdminModule),
  },

  {
    path: 'tickets',
    data: {
      roles: ['ADMIN', 'REVIEWER', 'ASSIGNEE', 'REMINDER', 'TELECALLER'],
      contentLayout: 'full-width',
      hideFooter: true,
      loaderPolicy: ticketingRouteLoaderPolicy,
    },
    canActivateChild: [AuthGuard],
    loadChildren: () =>
      import('./routes/route-ticketing.module').then(
        (m) => m.RouteTicketingModule,
      ),
  },
  {
    path: 'user',
    data: { roles: ['CUSTOMER'] },
    canActivateChild: [AuthGuard],
    loadChildren: () =>
      import('./routes/route-customer.module').then(
        (m) => m.RouteCustomerModule,
      ),
  },
  {
    path: 'packages',
    loadChildren: () =>
      import('./routes/route-packages.module').then(
        (m) => m.RoutePackagesModule,
      ),
  },
  {
    path: 'agent',
    loadChildren: () =>
      import('./routes/route-agent.module').then((m) => m.RouteAgentModule),
  },
  {
    path: 'agent-platform',
    data: {
      contentLayout: 'full-width',
      hideFooter: true,
      loaderPolicy: whatsappRouteLoaderPolicy,
    },
    loadChildren: () =>
      import('./routes/route-whatsapp.module').then(
        (m) => m.RouteWhatsappModule,
      ),
  },
  {
    path: 'thank-you',
    loadChildren: () =>
      import('./routes/route-thank-you.module').then(
        (m) => m.RouteThankYouModule,
      ),
    canActivate: [canActivateThankyou],
  },
  {
    path: 'login',
    component: LoginComponent,
    data: {
      contentLayout: 'full-width',
    },
    canActivate: [NotAuthGuard],
  },
  {
    path: 'signup',
    component: SignupComponent,
    data: {
      contentLayout: 'full-width',
    },
  },
  {
    path: '**',
    redirectTo: '',
    pathMatch: 'full',
  },
];

@NgModule({
  imports: [
    RouterModule.forRoot(routes, {
      scrollPositionRestoration: 'enabled',
    }),
  ],
  exports: [RouterModule],
})
export class AppRoutingModule {}
